import React, { useState, useRef } from 'react';
import Card from "../components/Card";
import AjaxDynamicDataTable from '@langleyfoxall/react-dynamic-data-table/dist/AjaxDynamicDataTable';
import LoadingIndicator from "../components/datatable/LoadingIndicator";
import EmptyTable from "../components/datatable/EmptyTable";
import {toast} from "react-toastify";
import {PRODUCT_PAGES} from "../pages/JobProductPage";
import ArchiveJobProductModal from "../modals/ArchiveJobProductModal";
import DuplicateJobProductModal from "../modals/DuplicateJobProductModal";

const JobProductDataTable = (props) => {
    const {
        jobId,
        parentId,
        onChangePage    = (CREATE, product) => {}
    } = props;

    const dataTableRef = useRef(null);

    const [duplicateJobProductModal, setDuplicateJobProductModal]   = useState(null);
    const [archiveJobProductModal, setArchiveJobProductModal]       = useState(null);

    const renderRowButton = (product) => {
        return (
            <td>
                <div className={"d-flex justify-content-end align-content-center align-items-center"}>
                    {!!product.can && (can('create', 'product') === true || product.can.update === true || product.can.delete === true) && (
                        <div className="dropdown">
                            <button
                                className="dropdown-toggle cursor-pointer text-eh-off-black h3"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <i className="far fa-ellipsis-h"/>
                            </button>
                            <div
                                className="dropdown-menu dropdown-menu-right p-0"
                                aria-labelledby="navbarDropdown"
                            >
                                {!!product.can.update === true && (
                                    <button className={"dropdown-item cursor-pointer"}
                                            onClick={() => onChangePage(PRODUCT_PAGES.EDIT, product)}
                                    >
                                        <span>Edit Product</span>
                                    </button>
                                )}
                                {can('create', 'product') === true && (
                                    <button className={"dropdown-item cursor-pointer"}
                                            onClick={() => setDuplicateJobProductModal(product)}
                                    >
                                        <span>Duplicate Product</span>
                                    </button>
                                )}
                                {!!product.can.delete === true && (
                                    <button className={"dropdown-item cursor-pointer"}
                                            onClick={() => setArchiveJobProductModal(product)}
                                    >
                                        <span>Delete Product</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </td>
        )
    }

    return (
        <React.Fragment>
            <Card
                title={"Products"}
                classes={"mh-100 border-0"}
                controls={can('create', 'product') ? (
                    <button onClick={(event) => {
                        event.preventDefault();
                        onChangePage(PRODUCT_PAGES.CREATE, null);
                    }} className={"btn font-weight-bold btn-eh-lilac px-4 m-0"}>
                        <i className={"far fa-plus-circle mr-2"} />
                        <span>{"Create Product"}</span>
                    </button>
                ) : null}
            >
                <div className={"row m-0 p-0"}>
                    <div className={"col-12 m-0 p-0"}>
                        <div className="data-table">
                            <AjaxDynamicDataTable
                                apiUrl={route('web-api.job.product.data-table', {job: jobId}).toString()}
                                loadingComponent={<LoadingIndicator />}
                                noDataComponent={<EmptyTable itemName="products" />}
                                fieldsToExclude={[
                                    'id',
                                    'created_at',
                                    'deleted_at',
                                    'can',
                                ]}
                                alwaysShowPagination
                                fieldOrder={[
                                    "reference",
                                    "name",
                                    "quantity",
                                    "price",
                                    "product_line_items_count",
                                ]}
                                fieldMap={{
                                    name:                       "Product Name",
                                    product_line_items_count:   "Parts"
                                }}
                                ref={dataTableRef}
                                defaultOrderByField={'id'}
                                defaultOrderByDirection={'asc'}
                                buttons={(row) => renderRowButton(row)}
                                dataItemManipulator={(field, value, row) => {
                                    switch (field) {
                                        case 'price':
                                            return (
                                                <span className={"text-eh-light-blue font-weight-bold"}>{value}</span>
                                            );
                                    }

                                    return <span>{value}</span>;
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Card>
            <DuplicateJobProductModal
                show={!!duplicateJobProductModal}
                jobId={jobId}
                productId={!!duplicateJobProductModal ? duplicateJobProductModal.id : null}
                parentId={parentId}
                onCancel={() => setDuplicateJobProductModal(null)}
                onComplete={(product) => {
                    setDuplicateJobProductModal(null)
                    dataTableRef.current.reload();
                    toast.success(<div>Product duplicated.</div>);
                }}
            />
            <ArchiveJobProductModal
                show={!!archiveJobProductModal}
                jobId={jobId}
                productId={!!archiveJobProductModal ? archiveJobProductModal.id : null}
                parentId={parentId}
                onCancel={() => setArchiveJobProductModal(null)}
                onComplete={(product) => {
                    setArchiveJobProductModal(null)
                    dataTableRef.current.reload();
                    toast.success(<div>Product deleted.</div>);
                }}
            />
        </React.Fragment>
    );
}

export default JobProductDataTable;
